<template>
  <div class="contact">
    <section class="section container">
      <h1 class="is-size-2-touch page-header">Contact Us</h1>
      <div class="columns">
        <div class="column is-three-fifths">
          <div class="mapouter">
            <div class="gmap_canvas">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3773.507154596638!2d72.79837471533486!3d18.953196860745255!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7cde31a05e5ad%3A0x3acc0a4bf378b876!2sSundatta%20Apartment%2C%20CLUSTER_MUMBAI-57%2C%20Mount%20Pleasant%20Rd%2C%20Malabar%20Hill%2C%20Mumbai%2C%20Maharashtra%20400006!5e0!3m2!1sen!2sin!4v1647787597420!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style="border:0;"
                allowfullscreen=""
                loading="lazy"
              ></iframe>
            </div>
            <!-- <style>.mapouter{overflow:hidden;height:auto;width:auto;}.gmap_canvas {background:none!important;height:500px;width:600px;}</style> -->
          </div>
        </div>
        <div class="column">
          <div class="columns container">
            <div class="column is-left is-narrow">
              <span class="icon fas fa-phone"></span>
            </div>
            <div class="column has-text-left">
              <a href="tel:+918879400099">+91-88794-00099</a>
            </div>
          </div>

          <div class="columns container">
            <div class="column is-left is-narrow">
              <span class="icon fas fa-at"></span>
            </div>
            <div class="column is-left has-text-left">
              <a href="mailto:partha@athcons.com">partha@athcons.com</a>
            </div>
          </div>

          <div class="columns container">
            <div class="column is-left is-narrow">
              <span class="icon fas fa-map-marker-alt"></span>
            </div>
            <div class="column is-left has-text-left">
              <p>6E, Sundatta Apartments</p>
              <p>Mount Pleasant Road, Malabar Hill</p>
              <p>Mumbai - 400006</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "contact",
  components: {},
};
</script>
